import { gsap, ScrollTrigger } from 'gsap/all'
import SplitText from 'gsap/SplitText'

const pageTransitions = {
  el: {
    main: document.querySelector<HTMLElement>('.main'),
    footer: document.querySelector<HTMLElement>('.footer'),
    headerNavigationItems: document.querySelectorAll<HTMLElement>(
      '.navigation .nav__item, .navigation .header-button'
    ),
    landingBlockSection: document.querySelector<HTMLElement>('.landing-block-section'),
    navigationLinks: document.querySelectorAll<HTMLElement>(`
      .header__logo,
      .navigation .nav__link,
      .footer-nav .nav__link,
      .subnav a,
      .navigation-box,
      .next-event-card,
      .events-card,
      .info-block .button
    `),
  },

  init(): void {
    this.el.navigationLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        this.handleNavigationLinkClick(event)
      })
    })

    this.handleLandingBlockSectionReveal()
    this.handlePageReveal()

    // handling page restore for mobile iOS - without this back/forward buttons won't visually reload the page
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        window.location.reload()
      }
    })
  },

  handleLandingBlockSectionReveal(): void {
    if (!this.el.landingBlockSection) return

    const el = gsap.utils.selector(this.el.landingBlockSection)
    const isPageLoaded = sessionStorage.getItem('pageLoaded')

    new SplitText(el('.heading--large p'), {
      tag: 'span',
      type: 'words',
      wordsClass: 'word',
    })

    gsap
      .timeline({ defaults: { ease: 'power3.out' } })
      .set(el('.word'), { opacity: 0, y: 23 }, 0)
      .set(el('.image-container, .shape-green'), { marginTop: 234 }, 0)
      .to(el('.word'), { duration: 1, opacity: 1, y: 0, stagger: 0.034 }, isPageLoaded ? 0.3 : 0.8)
      .to(el('.image-container'), { duration: 2.5, opacity: 1, marginTop: 0 }, 0.2)
      .to(el('.shape-green'), { duration: 2.5, opacity: 1, marginTop: 0 }, 0.3)
  },

  handleNavigationLinkClick(event): void {
    event.preventDefault()

    gsap.to([this.el.main, this.el.footer], {
      duration: 0.3,
      ease: 'power3.in',
      opacity: 0,
      onStart: () => {
        const activeElement = document.querySelector('.navigation .active')

        if (activeElement) {
          activeElement.classList.remove('active')
          activeElement.previousElementSibling.classList.remove('dot-visible')
        }
        event.target.previousElementSibling.classList.add('dot-visible')
        event.target.classList.add('active')
      },
      onComplete: () => {
        window.location.href = event.target.getAttribute('href')
      },
      y: -34,
    })
  },

  handlePageReveal(): void {
    const isPageLoaded = sessionStorage.getItem('pageLoaded')

    gsap.fromTo(
      [this.el.main, this.el.footer],
      {
        opacity: 0,
      },
      {
        duration: 1,
        ease: 'power3.out',
        opacity: 1,
        onComplete: () => {
          sessionStorage.setItem('pageLoaded', 'true')
        },
      }
    )

    gsap.fromTo(
      this.el.main.children,
      {
        opacity: 0,
        y: 0,
      },
      {
        delay: isPageLoaded ? 0 : 0.567,
        duration: 1,
        ease: 'power3.out',
        opacity: 1,
        y: 0,
        stagger: 0.1,
        onComplete: () => {
          ScrollTrigger.refresh()
        },
      }
    )

    setTimeout(() => {
      ScrollTrigger.refresh() // ? Added for better visual experience - this will force 2nd section to be visible on page load
    }, 567)

    if (!isPageLoaded) {
      gsap.fromTo(
        this.el.headerNavigationItems,
        {
          opacity: 0,
          y: 0,
        },
        {
          clearProps: 'all',
          ease: 'power3.out',
          opacity: 1,
          stagger: 0.05,
          y: 0,
        }
      )
    }
  },
}

export default pageTransitions
